import { LayersIcon, TrendingUpIcon, AppleIcon, ShieldIcon, BatteryChargingIcon, FlagIcon, CalendarDaysIcon, ZapIcon, ClipboardCheckIcon, ActivityIcon } from 'lucide-react';
export const phases = [{
  n: '01',
  name: 'Temel',
  short: 'Sağlam bir başlangıç yapın.',
  weeks: '1–8. haftalar',
  icon: LayersIcon,
  title: '01 — Temel',
  lead: 'Hazırlığınızın temelini oluşturun.',
  desc: 'Uzun mesafe hedefinize yönelik hazırlığa başlarken gerekli olan düzeni, tutarlılığı ve antrenman alışkanlıklarını oluşturmaya odaklanın. Bu aşama, sonraki dönemlerde geliştireceğiniz hazırlığın başlangıç noktasını belirlemenize yardımcı olur.'
}, {
  n: '02',
  name: 'Gelişim',
  short: 'Dayanıklılığınızı aşamalı olarak geliştirin.',
  weeks: '9–20. haftalar',
  icon: TrendingUpIcon,
  title: '02 — Gelişim',
  lead: 'Dayanıklılığınızı aşamalı olarak geliştirin.',
  desc: 'Antrenman hacminiz ve ihtiyaçlarınız arttıkça yüzme, bisiklet ve koşu çalışmalarınızı organize edin. Amaç, hazırlığınızın farklı parçalarını bir araya getirirken gelişiminizi aşamalı bir çerçevede takip etmektir.'
}, {
  n: '03',
  name: 'Beslenme',
  short: 'Antrenman ve yarış hazırlığında beslenme stratejinizi organize edin.',
  weeks: '21–30. haftalar',
  icon: AppleIcon,
  title: '03 — Beslenme',
  lead: 'Beslenme stratejinizi hazırlığınızla birlikte ele alın.',
  desc: 'Uzun antrenmanlarda enerji yönetimi, sıvı alımı ve beslenme planlaması daha fazla önem kazanır. Bu aşamada, beslenme yaklaşımınızı antrenman ve yarış hedeflerinizle birlikte değerlendirebileceğiniz bir çerçeve oluşturun.'
}, {
  n: '04',
  name: 'Koruma',
  short: 'Toparlanma, yük yönetimi ve hazırlık sürecinizi daha bilinçli takip edin.',
  weeks: '31–35. haftalar',
  icon: ShieldIcon,
  title: '04 — Koruma',
  lead: 'Hazırlığınızın farklı parçalarını bir araya getirin.',
  desc: 'Antrenman yükü, toparlanma ve sürdürülebilirlik konularını daha bilinçli şekilde ele alın. Hazırlığınızın yarış hedefinizle nasıl bağlantılı olduğunu değerlendirin ve ihtiyaçlarınıza uygun bir düzen oluşturun.'
}, {
  n: '05',
  name: 'Hazırlık',
  short: 'Yarış öncesindeki döneminizi planlayın.',
  weeks: '36–40. haftalar',
  icon: BatteryChargingIcon,
  title: '05 — Hazırlık',
  lead: 'Yarış öncesi döneminizi planlayın.',
  desc: 'Yarış yaklaşırken hazırlığınızı organize edin ve son dönemin amacını anlayın. Antrenman düzeninizin yanı sıra ekipman, yarış haftası ve başlangıç çizgisine hazırlık gibi pratik konulara odaklanın.'
}, {
  n: '06',
  name: "Yarış Uygulaması",
  short: "Hazırlığınızı yarış günü uygulamasına dönüştürün.\nYarış Uygulaması\n\nHazırlık sürecinizi, yarış günü sergileyeceğiniz performansa dönüştürün.",
  weeks: 'Yarış günü',
  icon: FlagIcon,
  title: '06 — Uygulama',
  lead: 'Hazırlığınızı yarış günü planına dönüştürün.',
  desc: 'Antrenman sizi başlangıç çizgisine getirir. Yarış günü uygulaması ise hazırlığınızı yönetmenize yardımcı olur. Tempo, beslenme, geçişler, ekipman ve yarış günü kararları gibi konuları tek bir pratik çerçevede bir araya getirin.'
}];
export const tools = [{
  verb: 'Planla',
  name: '40 HAFTALIK TRİATLON ANTRENMAN TAKVİMİ™',
  icon: CalendarDaysIcon
}, {
  verb: 'Beslen',
  name: 'TRİATLON BESLENME REHBERİ™',
  icon: ZapIcon
}, {
  verb: 'Hazırlan',
  name: 'YARIŞ HAFTASI KONTROL MERKEZİ™',
  icon: ClipboardCheckIcon
}, {
  verb: 'Takip et',
  name: 'TRİATLON GELİŞİM TAKİP ÇİZELGESİ™',
  icon: ActivityIcon
}];
export const systemIncludes = ['Yüzme antrenmanı için yapılandırılmış çerçeveler', 'Bisiklet antrenmanı organizasyonu', 'Koşu gelişimini planlamaya yönelik yaklaşımlar', 'Kuvvet ve destekleyici çalışmalar', 'Toparlanma konusunda dikkate alınması gereken noktalar', 'Antrenman organizasyonu', 'İlerleme takibi', 'Beslenme ilkeleri', 'Sıvı alımı konusunda dikkat edilmesi gerekenler', 'Yarış hazırlığı çerçeveleri', 'Yarış günü uygulama yaklaşımı', 'Pratik kontrol listeleri'];
export type BonusAccent = 'electric' | 'perf' | 'ember' | 'aqua';
export const bonuses: {
  n: string;
  accent: BonusAccent;
  title: string;
  subtitle: string;
  desc: string[];
  tagsLabel: string;
  tags: string[];
  price: string;
  cover: string;
}[] = [{
  n: '01',
  accent: 'electric',
  title: '40 HAFTALIK TRİATLON ANTRENMAN TAKVİMİ™',
  subtitle: 'Başlangıçtan yarış gününe kadar hazırlık sürecinizi görsel olarak organize etmenize yardımcı olan takvim.',
  desc: ['Uzun vadeli hazırlığınızın nasıl yapılandırılabileceğini görmek ve farklı aşamaları takip etmek için bir yol haritası oluşturun.'],
  tagsLabel: 'Takvimde yer alan ana dönemler:',
  tags: ['1–8. haftalar · TEMEL', '9–20. haftalar · GELİŞİM', '21–30. haftalar · BESLENME', '31–35. haftalar · KORUMA', '36–40. haftalar · HAZIRLIK'],
  price: '1.580 TRY',
  cover: 'https://cdn.magicpatterns.com/uploads/w7FEi5MadfASTKyz9VNYaq/Calendario_de_entrenamiento_triatlon_de_40_semanas.webp'
}, {
  n: '02',
  accent: 'perf',
  title: 'TRİATLON BESLENME REHBERİ™',
  subtitle: 'Antrenman ve yarış hazırlığınızda beslenme ile sıvı alımını organize etmenize yardımcı olan dijital rehber.',
  desc: ['Antrenman enerji gerektirir. Uzun mesafe yarışları ise planlama gerektirir.'],
  tagsLabel: 'Bu rehberde ele alınan konular:',
  tags: ['Günlük beslenme', 'Antrenman öncesi beslenme', 'Sıvı ve elektrolit yönetimi', 'Antrenman sırasında beslenme', 'Toparlanma beslenmesi', 'Yarış günü beslenme planlaması'],
  price: '1.430 TRY',
  cover: 'https://cdn.magicpatterns.com/uploads/bJeAufLpnbM1CpH6FtZL7X/Calendario_de_entrenamiento_triatlon_de_40_semanas_(1).webp'
}, {
  n: '03',
  accent: 'ember',
  title: 'YARIŞ HAFTASI KONTROL MERKEZİ™',
  subtitle: 'Yarış haftasından başlangıç çizgisine kadar hazırlığınızı organize etmenize yardımcı olan kontrol sistemi.',
  desc: ['Son hafta, son dakika kararlarıyla dolu olmak zorunda değil.'],
  tagsLabel: 'Şu konuları planlamanıza yardımcı olur:',
  tags: ['Yarış haftası planlaması', 'Seyahat organizasyonu', 'Ekipman kontrolü', 'Yüzme hazırlığı', 'Bisiklet hazırlığı', 'Koşu hazırlığı', 'Yarış sabahı', 'Başlangıç çizgisi hazırlığı'],
  price: '1.580 TRY',
  cover: 'https://cdn.magicpatterns.com/uploads/tM5BumBUQ3TLWABSQaqdEB/Calendario_de_entrenamiento_triatlon_de_40_semanas_(2).webp'
}, {
  n: '04',
  accent: 'aqua',
  title: 'TRİATLON GELİŞİM TAKİP ÇİZELGESİ™',
  subtitle: 'Antrenmanlarınızı takip edin. Gelişiminizi değerlendirin. Tutarlılığınızı koruyun.',
  desc: ['Hazırlığınızda neler olduğunu görebildiğinizde, sürecinizi değerlendirmek daha kolay hale gelir.'],
  tagsLabel: 'Bu takip çizelgesiyle üç disiplindeki hazırlığınızı organize edin:',
  tags: ['Yüzme', 'Bisiklet', 'Koşu', 'Antrenman yükü', 'Toparlanma', 'Haftalık tutarlılık'],
  price: '1.330 TRY',
  cover: 'https://cdn.magicpatterns.com/uploads/wMB6k3A2asmC35zQjs4EtS/Calendario_de_entrenamiento_triatlon_de_40_semanas_(3).webp'
}];
export const idealFor = ['Uzun mesafe triatlon yarışına hazırlanan sporcular', 'Dayanıklılık antrenmanlarını daha sistematik organize etmek isteyenler', 'Yüzme, bisiklet ve koşu hazırlığını birlikte planlamak isteyenler', 'Hazırlık süreci için net bir yol haritasına ihtiyaç duyanlar', 'Antrenman sürecini daha düzenli hale getirmek isteyen deneyimli sporcular'];
export const offerIncludes = ['6 aşamalı uzun mesafe triatlon hazırlık sistemi', 'TEMEL', 'GELİŞİM', 'BESLENME', 'KORUMA', 'HAZIRLIK', 'UYGULAMA', 'Yüzme / Bisiklet / Koşu hazırlık çerçevesi', 'Beslenme ve sıvı alımı çerçevesi', 'Yarış hazırlığı ve yarış günü uygulama yaklaşımı'];